var CompanyManage = function () { return import('~/pages/system-manage/company-manage.vue'); };
var RoleManage = function () { return import('~/pages/system-manage/role-manage.vue'); };
var UserManage = function () { return import('~/pages/system-manage/user-manage.vue'); };
var SystemParameterManage = function () { return import('~/pages/system-manage/system-parameter-manage.vue'); };
var SystemLog = function () { return import('~/pages/system-manage/system-log.vue'); };
export default [
    {
        // 公司管理
        path: '/system-manage/company-manage',
        name: 'company-manage',
        component: CompanyManage
    },
    {
        // 角色管理
        path: '/system-manage/role-manage',
        name: 'role-manage',
        component: RoleManage
    },
    {
        // 用户机构管理
        path: '/system-manage/user-manage',
        name: 'user-manage',
        component: UserManage
    },
    {
        // 系统参数管理
        path: '/system-manage/system-parameter-manage',
        name: 'system-parameter-manage',
        component: SystemParameterManage
    },
    {
        // 系统日志
        path: '/system-manage/system-log',
        name: 'system-log',
        component: SystemLog
    },
];
